$(document).ready(function () {

    if ($("#community_floorplan_grid_view_btn").hasClass("active")) {

        //Enable grid view 
        $("#community_floorplan_grid_view").removeClass('hidden');
        $('#community_floorplan_grid_view_btn').addClass('button--blue--solid active');

        //Disable list view
        $('#community_floorplan_list_view').addClass('hidden');
        $('#community_floorplan_list_view_btn').removeClass('button--blue--solid active');
        $('#community_floorplan_list_view_btn').addClass('button--blue');

    } else {
        //Enable list view 
        $("#community_floorplan_list_view").removeClass('hidden');
        $('#community_floorplan_list_view_btn').addClass('button--blue--solid active');

        //Disable grid view
        $('#community_floorplan_grid_view').addClass('hidden');
        $('#community_floorplan_grid_view_btn').removeClass('button--blue--solid active');
        $('#community_floorplan_grid_view_btn').addClass('button--blue');
    }

    $("#community_floorplan_grid_view_btn").click(

        function () {

            $("#community_floorplan_grid_view").removeClass('hidden');
            $('#community_floorplan_grid_view_btn').addClass('button--blue--solid active');
            $('#community_floorplan_grid_view_btn').removeClass('button--blue');

            $('#community_floorplan_list_view').addClass('hidden');
            $('#community_floorplan_list_view_btn').removeClass('button--blue--solid active');
            $('#community_floorplan_list_view_btn').addClass('button--blue');

            $("#community_floorplan_grid_view_btn").blur(); //hackfix: force style to apply
        }

    );

    $("#community_floorplan_list_view_btn").click(

        function () {

            $("#community_floorplan_list_view").removeClass('hidden');
            $('#community_floorplan_list_view_btn').addClass('button--blue--solid active');
            $('#community_floorplan_list_view_btn').removeClass('button--blue');

            $('#community_floorplan_grid_view').addClass('hidden');
            $('#community_floorplan_grid_view_btn').removeClass('button--blue--solid active');
            $('#community_floorplan_grid_view_btn').addClass('button--blue');

            $("#community_floorplan_list_view_btn").blur(); //hackfix: force style to apply
        }

    );

});